import Vue from "vue";
import Vuex from "vuex";

import axios from "axios";

import { cloneDeep } from "lodash-es";

Vue.use(Vuex);

import common_module from "@/store/common_module.js";

export default new Vuex.Store({
  strict: true,
  modules: {
    common: common_module
  },
  state: {
    client_end: "admin",
    store: {
      license_info: null,
      current_admin_details: {},
      current_admin_notices: null,
      managed_active_admins_details: [], // futuristic - current wpcal admin type is administrator only
      wpcal_site_urls: {},
      is_admin_end_access_granted: true
    }
  },
  mutations: {
    set_license_info: (state, value) => {
      state.store.license_info = value;
    },
    set_managed_active_admins_details: (state, value) => {
      state.store.managed_active_admins_details = value;
    },
    set_store_by_obj: (state, value_obj) => {
      for (let prop in value_obj) {
        if (state.store.hasOwnProperty(prop)) {
          state.store[prop] = value_obj[prop];
        }
      }
    }
  },
  getters: {
    // get_client: state => state.client,
    // get_store: state => state.store,
    get_license_info: state => state.store.license_info,
    get_current_admin_details: state => state.store.current_admin_details,
    get_current_admin_notices: state => state.store.current_admin_notices,
    get_managed_active_admins_details: state =>
      state.store.managed_active_admins_details,
    get_managed_active_admins_for_host_filter: state => {
      let admins = cloneDeep(state.store.managed_active_admins_details);
      if (Array.isArray(admins)) {
        let all_admin_as_admin = {
          admin_user_id: "0",
          admin_type: "administrator",
          status: "1",
          name: "All",
          firstname: "",
          display_name: "All",
          user_email: "All"
        };
        admins.unshift(all_admin_as_admin);
      }
      return admins;
    },
    get_admin_details: state => admin_user_id => {
      let admin_details = {};
      let admins = cloneDeep(state.store.managed_active_admins_details);
      let found_admin_details = admins.find(
        _admin_details => _admin_details.admin_user_id == admin_user_id
      );
      return found_admin_details ? found_admin_details : admin_details;
    },
    get_wpcal_site_urls: state => state.store.wpcal_site_urls,
    get_is_admin_end_access_granted: state =>
      state.store.is_admin_end_access_granted
  },
  actions: {
    load_managed_active_admins_details(context) {
      let wpcal_request = {};
      let action_managed_active_admins_details =
        "get_managed_active_admins_details_for_current_admin";
      wpcal_request[action_managed_active_admins_details] = "dummy__";

      let post_data = {
        action: context.getters.get_ajax_main_action,
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data, {
          params: { _remove_options_before_call: { background_call: true } }
        })
        .then(response => {
          if (
            response.data[action_managed_active_admins_details].status ===
              "success" &&
            response.data[action_managed_active_admins_details]
              ?.managed_active_admins_details
          ) {
            context.commit(
              "set_managed_active_admins_details",
              response.data[action_managed_active_admins_details]
                .managed_active_admins_details
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
});
